<template>
  <div class="detalle-estado-acuerdo-comercial">

    <!-- Header detalle del estado -->
    <div class="d-flex label label--header align-start contenedor-header-detalle-estado justify-space-between">
      <div>

        <!-- Fecha de creación -->
        <div>
          <span class="label--texto-oscuro">Creación:</span>
          <span class="ml-1">
            {{ acuerdo_comercial.fecha_creacion | formatFecha('dd/MM/yyyy HH:mm') }} hs{{ acuerdo_comercial.usuario_sales ? ',' : '' }}
            {{ acuerdo_comercial.usuario_sales | trimUsuarioSales }}
          </span>
        </div>

        <!-- Fecha de última actualización (opcional) -->
        <div v-if="acuerdo_comercial.fecha_edicion">
          <span class="label--texto-oscuro">Últ. modificación:</span>
          <span class="ml-1">
            {{ acuerdo_comercial.fecha_edicion | formatFecha('dd/MM/yyyy HH:mm') }} hs,
            {{ acuerdo_comercial.usuario_edicion | trimUsuarioSales }}
          </span>
        </div>
      </div>

      <div class="label label--rechazada label--gris">
        {{ acuerdo_comercial.origen_formateado }}
      </div>

    </div>

    <!-- Detalle del estado -->
    <div class="detalle-estado" :class="'detalle-estado--' + colorDetalleEstado()">

      <!-- Caso base administración -->
      <div v-if="acuerdo_comercial.tipo_propuesta === TIPO_ACUERDO_ADMINISTRACION" class="label">
        <chip-estado-acuerdo-comercial :estado="TIPO_ESTADO_ACUERDO_COMERCIAL_ADMINISTRACION" />
      </div>

      <!-- Consorcio -->
      <div v-else class="d-flex flex-column align-start justify-space-between ancho-completo">

        <!-- Chips estado actual / mapeo siguiente estado + variantes de labels  -->
        <div class="d-flex align-end justify-space-between ancho-completo">

          <!-- Label estado + chip estado actual + icono y estado siguiente -->
          <div class="d-flex align-end">

            <!-- Label estado -->
            <div class="label label--siguiente-estado mr-2" v-if="mostrar_siguiente_estado">
              {{ solo_cambios_atributos_internos ? 'Sin cambios en el estado actual:' : 'Próximo estado del acuerdo:' }}
            </div>

            <!-- Tooltip + chip estado actual + icono + chip estado siguiente -->
            <div class="d-flex align-center">

              <!-- Tooltip chip estado -->
              <ca-tooltip
                posicion="arriba"
                solo-texto
                :texto="textoTooltipChipEstado(acuerdo_comercial.estado)"
                customActivator
              >
                <template slot="customActivator">
                  <chip-estado-acuerdo-comercial :estado="acuerdo_comercial.estado" />
                </template>
              </ca-tooltip>

              <!-- Icono de mapeo de siguiente estado -->
              <v-icon v-if="mostrar_siguiente_estado && !SIN_SIGUIENTE_ESTADO_MAPEO.includes(acuerdo_comercial.estado) && !solo_cambios_atributos_internos" class="ml-1 mr-1 icono-siguiente-estado" size="16px">arrow_forward</v-icon>

              <!-- Tooltip chip estado siguiente -->
              <ca-tooltip
                v-if="mostrar_siguiente_estado && !SIN_SIGUIENTE_ESTADO_MAPEO.includes(acuerdo_comercial.estado) && !solo_cambios_atributos_internos"
                posicion="arriba"
                solo-texto
                :texto="textoTooltipChipEstado(siguienteEstado)"
                customActivator
              >
                <template slot="customActivator">
                  <chip-estado-acuerdo-comercial :estado="siguienteEstado" />
                </template>
              </ca-tooltip>

            </div>

          </div>

          <!-- Label días restantes -->
          <div v-if="acuerdo_comercial.propuesta_consorcio.dias_restantes && !acuerdo_comercial.expirada && !mostrar_siguiente_estado" class="label">

            <span>{{ acuerdo_comercial.propuesta_consorcio.dias_restantes === 1 ? 'Resta' : 'Restan' }}</span>

            <!-- Label días restantes (variante de danger para pocos días restantes) -->
            <span class="label--texto-oscuro" :class="{'label--danger': acuerdo_comercial.propuesta_consorcio.dias_restantes <= 5}">
              {{ acuerdo_comercial.propuesta_consorcio.dias_restantes }}

              <!-- Caso borde (día) -->
              {{  acuerdo_comercial.propuesta_consorcio.dias_restantes === 1 ? ' día' : ' días'}}
            </span>

            <span>para aceptar</span>

          </div>

          <!-- Label fecha de expiración (opcional, depende del flag mostrar siguiente estado) + chip expirado -->
          <div class="d-flex align-end" v-if="acuerdo_comercial.expirada">

            <!-- Label fecha expiración -->
            <div v-if="!mostrar_siguiente_estado" class="label label--gris">
              Expiración: {{ acuerdo_comercial.fecha_expiracion | formatFecha('dd/MM/yyyy') }}
            </div>

            <!-- Chip expirado -->
            <chip-estado-acuerdo-comercial :estado="TIPO_ESTADO_ACUERDO_COMERCIAL_EXPIRADO" class="ml-2" />

          </div>

          <!-- Label fecha de aceptación / fecha de primera facturación -->
          <div v-else-if="(acuerdo_comercial.estado === TIPO_ESTADO_ACUERDO_COMERCIAL_ACEPTADA || acuerdo_comercial.estado === TIPO_ESTADO_ACUERDO_COMERCIAL_FACTURANDO) && !mostrar_siguiente_estado" class="label label--gris">
            {{ acuerdo_comercial.estado === TIPO_ESTADO_ACUERDO_COMERCIAL_ACEPTADA ? 'Aceptación: ' : 'Primera facturación: ' }}
            {{ acuerdo_comercial.fecha_cambio_estado_actual | formatFecha('dd/MM/yyyy') }}
          </div>

        </div>

        <!-- Labels de estado rechazado (motivo y detalles de rechazo) -->
        <div class="mt-4 label label--rechazada contenedor-labels-rechazo" v-if="!mostrar_siguiente_estado && acuerdo_comercial.estado === TIPO_ESTADO_ACUERDO_COMERCIAL_RECHAZADA">
          <span class="label--texto-oscuro">Solicitud de contacto enviada por el cliente</span>
          <!-- Motivo -->
          <div>
            <span class="label--texto-oscuro">Fecha:</span>
            <span class="ml-1">{{ acuerdo_comercial.fecha_cambio_estado_actual | formatFecha('dd/MM/yyyy, HH:mm') }} hs</span>
          </div>

          <!-- Detalles -->
          <div>
            <span class="label--texto-oscuro">Mensaje:</span>
            <span class="ml-1">{{ acuerdo_comercial.rechazo_detalles }}</span>
          </div>

        </div>

      </div>
    </div>

  </div>

</template>

<script>
import { AcuerdoComercial } from '@/models/AcuerdoComercial';
import { TipoAcuerdo, TiposEstadosAcuerdoComercial } from '../acuerdo-comercial.consts';
import { trimUsuarioSales } from '../acuerdo-comercial.helpers';
import ChipEstadoAcuerdoComercial from './ChipEstadoAcuerdoComercial.vue';
import { METADATA_GETTER_MAPEO_ESTADOS } from '@/store/metadata/metadata.types';

/**
 * La idea de este componente esta separado en tres partes grandes:
 * 
 * 1. Header con el detalle del estado del acuerdo comercial. Incluye la fecha de creación y la última modificación del mismo (opcional).
 * 
 * 2. Caso base: Administración (solo se muestra el chip sin ninguna variante).
 * 
 * 3. Detalle del estado del acuerdo comercial:
 *       Si el flag de mostrar el siguiente estado esta deshabilitado, se verá lo siguiente:
 *        Detalle de estados base (no se visualiza el mapeo de siguiente estado)
 *        En caso de que el acuerdo este aceptado o facturando, se muestra la fecha de aceptación o la fecha de primera facturación respectivamente.
 *        
 *        Si el acuerdo comercial no esta expirado       
 *          Se mostrará los detalles del estado actual del acuerdo comercial y se indicarán los días restantes para aceptar el acuerdo.
 *        Por otro lado si el acuerdo esta expirado
 *          Solo se mostrará la fecha de expiración y el chip de expirado.
 * 
 *      Si el flag de mostrar el siguiente estado esta habilitado, se verá lo siguiente:
 *        Detalle de estados con el siguiente estado (se muestra el mapeo de siguiente estado).
 *        Se vera el estado actual y el siguiente estado del acuerdo comercial.
 * 
 *        En caso de que el acuerdo este expirado
 *          Se mostrará el chip de expirado tambien. 
 *        
 *        Hay casos borde donde no se muestra el siguiente estado como un mapeo, solo se mostrará el chip del estado actual, estos estados son los siguientes:
 *          - Actualizada
 *          - Renegociada 
 */
export default {
  name: 'DetalleEstadoAcuerdoComercial',
  components: {
    ChipEstadoAcuerdoComercial
  },
  props: {
    acuerdo_comercial: { type: AcuerdoComercial, default: null  },
    mostrar_siguiente_estado: { type: Boolean, default: false },
    solo_cambios_atributos_internos: { type: Boolean, default: false } // Flag para saber si solo se editaron los atributos internos del acuerdo comercial
  },
  data() {
    return {
      TIPO_ACUERDO_ADMINISTRACION: TipoAcuerdo.ADMINISTRACION,
      TIPO_ACUERDO_CONSORCIO: TipoAcuerdo.CONSORCIO,
      TIPO_ESTADO_ACUERDO_COMERCIAL_ADMINISTRACION: TiposEstadosAcuerdoComercial.ADMINISTRACION,
      TIPO_ESTADO_ACUERDO_COMERCIAL_RECHAZADA: TiposEstadosAcuerdoComercial.RECHAZADA,
      TIPO_ESTADO_ACUERDO_COMERCIAL_ACEPTADA: TiposEstadosAcuerdoComercial.ACEPTADA,
      TIPO_ESTADO_ACUERDO_COMERCIAL_FACTURANDO: TiposEstadosAcuerdoComercial.FACTURANDO,
      TIPO_ESTADO_ACUERDO_COMERCIAL_EXPIRADO: TiposEstadosAcuerdoComercial.EXPIRADO,
      TIPO_ESTADO_ACUERDO_COMERCIAL_ACTUALIZADA: TiposEstadosAcuerdoComercial.ACTUALIZADA,
      TIPO_ESTADO_ACUERDO_COMERCIAL_RENEGOCIADA: TiposEstadosAcuerdoComercial.RENEGOCIADA,
      SIGUIENTE_ESTADO: null, // Indicá el siguiente estado del acuerdo comercial (si es que tiene en el mapeo de estados en meta)
      SIN_SIGUIENTE_ESTADO_MAPEO: [TiposEstadosAcuerdoComercial.ACTUALIZADA, TiposEstadosAcuerdoComercial.RENEGOCIADA]
    };
  },
  computed: {

    /**
     * Retorna el siguiente estado del acuerdo comercial o null en caso de que no tenga un siguiente estado o el flag de mostrar el siguiente estado sea deshabilitado
     */
    siguienteEstado() {
      return this.mostrar_siguiente_estado ? this.$store.getters[METADATA_GETTER_MAPEO_ESTADOS][this.acuerdo_comercial.estado] : null;
    }
  },
  methods: {
    trimUsuarioSales,

    /**
     * Retorna el color del detalle del estado del acuerdo comercial, dependiendo de:
     * 
     * 1. Si el tipo de acuerdo es administración
     * 2. Si se encuentra expirada
     * 3. Si se usa para mostrar el mapeo de siguiente estado
     */
    colorDetalleEstado() {

      // Caso base administración
      if(this.acuerdo_comercial.tipo_propuesta === TipoAcuerdo.ADMINISTRACION) {
        return 'actual';
      }else{

        // Detalle de acuerdo comercial base
        if(!this.mostrar_siguiente_estado) {
          return this.acuerdo_comercial.expirada ? 'expirada' : 'actual';
        }

        // Detalle de acuerdo comercial siguiente estado
        return 'siguiente-estado';
      }

    },

    /**
     * Retorna el texto que se muestra en el tooltip del chip del estado del acuerdo comercial, en base al estado pasado por parámetro
     */
    textoTooltipChipEstado(estado) {
      switch(estado) {
      case TiposEstadosAcuerdoComercial.NUEVA:
        return 'El acuerdo aún no tuvo modificaciones desde que fue enviado al cliente.';
      case TiposEstadosAcuerdoComercial.ACTUALIZADA:
        return 'El acuerdo tuvo una o más modificaciones desde que fue enviado. Para más información, consultá el historial completo.';
      case TiposEstadosAcuerdoComercial.RECHAZADA:
        return 'El cliente rechazó el último acuerdo enviado.';
      case TiposEstadosAcuerdoComercial.RENEGOCIADA:
        return 'El acuerdo tuvo una o más modificaciones desde que fue rechazado por el cliente. Para más información, consultá el historial completo.';
      case TiposEstadosAcuerdoComercial.ACEPTADA:
        return 'El cliente aceptó el último acuerdo enviado.';
      case TiposEstadosAcuerdoComercial.FACTURANDO:
        return 'El acuerdo ya entró en ciclo de facturación.';
      }
    },
  }

};
</script>

<style lang="scss">
.detalle-estado-acuerdo-comercial {
  border-radius: 5px;
  border: 1px solid color(celeste-claro);
  background: color(blanco);
  overflow: auto; // Para evitar que se superponga el background color con el del border radius

  .icono-siguiente-estado {
    color: color(gris);
  }

  .contenedor-header-detalle-estado {
    padding: 12px 16px;
  }

  .label {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    color: color(dark);

    &--header {
      font-size: 13px;
      line-height: 19.5px;
      font-weight: 400;
      color: color(gris-oscuro);
    }

    &--texto-oscuro {
      font-weight: 700;
    }

    &--danger {
      color: color(rojo-error);
    }

    &--gris {
      color: color(gris);
      font-weight: 500;
    }

    &--siguiente-estado {
      font-weight: 500;
    }

    &--rechazada {
      font-size: 13px;
      line-height: 18px;
      font-weight: 400;
    }
  }

  .contenedor-labels-rechazo {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .ancho-completo {
    width: 100%;
  }

  .detalle-estado {
    padding: 12px 16px;
    border-top: 1px solid color(celeste-claro);

    .v-chip {
      margin: 0;
    }

    &--actual {
      background-color: color(fondo-claro);
    }

    &--expirada {
      background-color: #FFF4F4; // [ToDo] Agregar color a variables globales
    }

    &--siguiente-estado {
      background-color: color(naranja-claro-secund);
    }
  }

}
</style>